export default function MultipleChoice() {
  return null;
}
